var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMergedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9994 4.33329L8.99935 4.33329C5.66602 4.33329 4.33268 5.66663 4.33268 8.99996L4.33268 13C4.33268 16.3333 5.66602 17.6666 8.99935 17.6666L12.9993 17.6666C16.3327 17.6666 17.666 16.3333 17.666 13L17.666 8.99996C17.666 5.66663 16.3327 4.33329 12.9994 4.33329Z",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.6666L11 4.33329",
    stroke: "#4E3E91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergedIcon);
export default __webpack_public_path__ + "static/media/merged-icon.11e71a16f1e9f0c720795e953860b4a7.svg";
export { ForwardRef as ReactComponent };